export const peppolDefaultConfigurations = {};
